const UPDATE_RFI_RETURN_VALUE = "update-rfi";

export function rfiPathFromUpdateRfi(
  pathname: "/revised-rfi" | "/rfi-tracker",
  projectId: string | undefined,
  mode?: "upload",
): string {
  const params = new URLSearchParams();
  if (mode) params.set("mode", mode);
  if (projectId) params.set("projectId", projectId);
  params.set("returnTo", UPDATE_RFI_RETURN_VALUE);
  return `${pathname}?${params.toString()}`;
}

export function updateRfiReturnPath(projectId: string): string {
  const params = new URLSearchParams({ projectId, stage: "coverage" });
  return `/databook-builder?${params.toString()}`;
}
